import { createAction, props } from '@ngrx/store'
import { ChatMessage, ChatSendErrorCode, OutboxEntry } from '../app.state'

/**
 * The chat outbox: the sender's messages the server hasn't saved yet. The component queues a
 * message; ChatOutboxEffects sends it and reports back with the actions below.
 */

/** A new message from the compose box - shown straight away, sent by ChatOutboxEffects. */
export const queueChatMessage = createAction(
  '[Chat Outbox] Queue Message',
  props<{ entry: OutboxEntry }>()
)

/** Resend a message that's waiting or wasn't sent. `auto`: by itself on reconnect, not a tap. */
export const retryChatMessage = createAction(
  '[Chat Outbox] Retry Message',
  props<{ client_msg_id: string; auto?: boolean }>()
)

/** The socket is down - the message goes when it's back. */
export const chatMessageWaiting = createAction(
  '[Chat Outbox] Message Waiting',
  props<{ client_msg_id: string }>()
)

/** The backend saved it. `chat` is the saved message, from the ack. */
export const chatMessageSent = createAction(
  '[Chat Outbox] Message Sent',
  props<{ client_msg_id: string; chat?: ChatMessage }>()
)

export const chatMessageFailed = createAction(
  '[Chat Outbox] Message Failed',
  props<{ client_msg_id: string; error: ChatSendErrorCode }>()
)

/** "Delete", or "Edit" (which moves it back into the compose box). */
export const removeOutboxMessage = createAction(
  '[Chat Outbox] Remove Message',
  props<{ client_msg_id: string }>()
)

/** This device's saved outbox for the logged-in corp member, after a reload or login. */
export const chatOutboxRestored = createAction(
  '[Chat Outbox] Restored',
  props<{ entries: OutboxEntry[] }>()
)

/** Logout: the next person on this device mustn't see - or send - these. */
export const chatOutboxCleared = createAction('[Chat Outbox] Cleared')
